import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const downloadFile = (data: string, name: string, type?: string) => {
    const element = document.createElement('a');
    element.download = name;

    element.href = data;
    if (type) {
        element.type = type;
    }
    element.click();
    element.remove();
};

const downloadFileFromData = (prefix: string, data: string, filename: string) => {
    const link = window.document.createElement('a');
    link.setAttribute('href', prefix + encodeURI(data.toString()).replaceAll('#', '%23'));
    link.setAttribute('download', filename);
    link.click();
    link.remove();
};

export const downloadXLSX = (rows: (string | number)[][], filename: string) => {
    const wb = XLSX.utils.book_new();
    wb.Props = {
        Title: filename,
        // Subject: props.filename,
        Author: 'Skladon',
        CreatedDate: new Date(),
    };
    const sheetName = filename.length > 31 ? 'Export' : filename;
    wb.SheetNames.push(sheetName);

    const ws = XLSX.utils.aoa_to_sheet(rows);

    wb.Sheets[sheetName] = ws;
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

    const s2ab = (s: any): ArrayBuffer => {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };

    saveAs(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), `${filename}.xlsx`);
};

export const downloadCSV = (rows: (string | number)[][], filename: string) => {
    const csvContent = `${rows
        .map((row) =>
            row
                .map((col: any) =>
                    col && col.indexOf && col.indexOf(',') > -1 ? `"${col.replaceAll(',', ', ')}"` : col
                )
                .join(',')
        )
        .join('\n')}`;

    downloadFileFromData('data:text/csv;charset=utf-8,%EF%BB%BF', csvContent, `${filename}.csv`);
};

export default downloadFile;
